module.exports = __webpack_public_path__ + "img/dzdp.f372cbd3.png";